<template>
	<PageLoading :is-loading="isLoading"></PageLoading>
	<SideComponent @scrollto="scroll"></SideComponent>
	<NewIndexSiteLayout>
		<template #hero>
			<div class="index-pic">
				<Swiper :list="banners" :show-header="false"/>
				<div class="pic-wrapper">
					<search-bar-pic :isNeedRedirect="false" @searchKeywords="searchNews"></search-bar-pic>
				</div>
			</div>
		</template>
		<div class="container" ref="viewBox">
			<div class="content">
				<div class="news-container">
					<section id="news-wrapper" class="news-wrapper">
						<div class="news-left">
							<span class="text-style">{{$t('news.news')}}</span>
						</div>
						<div class="news-right" id="newslist">
							<div class="news-item" v-for="item in newsList" @click="toDetail(item.id)">
								<div class="news-item-outer">
									<div class="img-outer">
										<img :src="item.thumb" oncontextmenu="return false" :alt="item.title"/>
									</div>
									<div class="news-title">
										<span v-html="item.title"></span>
									</div>
								</div>
							</div>
						</div>
					</section>
					<div class="loadmore">
						<Loading :is-loading="isPicLoading"></Loading>
						<span class="more" @click="loadMore()" v-if="!nomore">{{$t('loadmore')}}</span>
						<span class="end" v-if="nomore">- {{$t('theEnd')}} -</span>
					</div>
				</div>
			</div>
			<Footer/>
		</div>
	</NewIndexSiteLayout>
</template>

<script>
	import news from './news_controller';
	export default news;
</script>

<style src="@/assets/css/news.css" scoped></style>
